import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from "react";
export var DebounceChange = /*#__PURE__*/function (_React$Component) {
  _inherits(DebounceChange, _React$Component);

  function DebounceChange() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DebounceChange);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DebounceChange)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      timer: null,
      value: _this.props.value
    }, _this.handleChange = function (event) {
      event.persist();
      var timer = _this.state.timer;

      if (timer) {
        clearTimeout(timer);
      }

      _this.setState({
        timer: setTimeout(function () {
          return _this.props.debounce(event);
        }, _this.props.time || 200),
        value: event.target.value
      });
    }, _assertThisInitialized(_this)));
  }

  _createClass(DebounceChange, [{
    key: "render",
    value: function render() {
      return this.props.children({
        change: this.handleChange,
        value: this.state.value
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var resetValue = props.resetValue,
          propsValue = props.value;
      var timer = state.timer,
          stateValue = state.value;

      if (resetValue) {
        if (timer) {
          clearTimeout(timer);
        }

        return {
          value: propsValue,
          timer: timer
        };
      }

      if (propsValue !== stateValue && timer === null) {
        return {
          value: propsValue
        };
      }

      return null;
    }
  }]);

  return DebounceChange;
}(React.Component);
export default DebounceChange;